export default __webpack_public_path__ + "static/media/about-page-img.9bc65c24.png";